import { Link } from "expo-router";
import React from "react";
import { Image } from "react-native";
import { Spacer } from "~/components/Spacer";
import { Text } from "~/components/Text";
import { View } from "~/components/View";
import { styleConstants } from "~/style/styleConstants";
import { useResponsive } from "../live-chat/useResponsive";
import { AppleAppStoreButton } from "./AppleAppStoreButton";
import { GooglePlayStoreButton } from "./GooglePlayStoreButton";

export function SectionBokBokLiveApp2Images() {
  const r = useResponsive();
  return (
    <View
      paddingHorizontalSmall={r(true, false, false)}
      paddingHorizontalExtraLarge={r(false, true, true)}
    >
      <View
        flexDirectionRow
        centerContent
        style={{ gap: styleConstants.spacingMedium }}
      >
        <View
          style={{
            width: r("40%", "25%", "33%"),
            aspectRatio: 436 / 886,
          }}
        >
          <Image
            style={{
              width: "100%",
              height: "100%",
            }}
            source={require("./bokbok-live-app-01.png")}
          />
        </View>
        <View
          style={{
            width: r("40%", "25%", "33%"),
            aspectRatio: 436 / 886,
            marginTop: 100,
          }}
        >
          <Image
            style={{
              width: "100%",
              height: "100%",
            }}
            source={require("./bokbok-live-app-02.png")}
          />
        </View>
      </View>

      <Spacer large />

      <Text sizeExtraLarge weightExtraBold alignCenter>
        {intl.formatMessage({
          id: "D5auGy",
          defaultMessage:
            "Or download the BokBok Live app on the Google or Apple app store",
          description: "Text below app store download buttons",
        })}
      </Text>

      <Spacer extraLarge />

      <View
        flexDirectionRow
        centerContent
        style={{ gap: styleConstants.spacingMedium }}
      >
        <Link
          href="https://play.google.com/store/apps/details?id=bokbok.live.app"
          target="_blank"
          aria-label={intl.formatMessage({
            defaultMessage: "Button Get It On Google Play",
            description: "Button aria-label",
            id: "I8Xq/b",
          })}
        >
          <GooglePlayStoreButton size={r(171, 190, 220)} />
        </Link>

        <Link
          href="https://apps.apple.com/us/app/bokbok-live-app/id6514317653"
          target="_blank"
          aria-label={intl.formatMessage({
            defaultMessage: "Download on the App Store",
            description: "Button aria-label",
            id: "/041/x",
          })}
        >
          <AppleAppStoreButton size={r(151.2, 168, 194.52)} />
        </Link>
      </View>
    </View>
  );
}
